import { getRequest } from '@/core';
import { vendors } from '@/requests';

export default async function getVendorsRequest(filter) {
	let url = vendors.getPath();
	try {
		let response = await getRequest(url,filter);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
